<template>
    <div class="center">
		<div class="center_title">
			<div class="center_title_img">
				<img src="../../images/icon_center_1.png"/>
			</div>

			<div class="center_title_text">
				<div>店铺名称：{{name_J}}</div>
				<div>{{iphone_J}}</div>
			</div>
		</div>

		<div class="center_title older">
			<h5>订单管理</h5>
			<div class="center_orders">
				<router-link tag="div" to="/waitingfororders" >
					<img src="../../images/book_1.png" />
					<div>待接单</div>
				</router-link>
				<router-link tag="div" to="/receivedorders">
					<img src="../../images/bluecheck.png" />
					<div>已接单</div>
				</router-link>
			</div>
		</div>

		<div class="address">
			<div v-on:click="address">
				<span>地址管理</span>
				<img src="../../images/dir_blue.png" />
			</div>
			<div @click="amendPass()">
				<span>修改密码</span>
				<img src="../../images/dir_blue.png" />
			</div>
		</div>
		<button v-on:click="login">退出登录</button>
	</div>
</template>
<script>
import API from "../../lmj_Api/api";
export default {
    data(){
        return{
			name:"hyHome",
			uid: this.$store.getters.get_user_id,
			name_J:"",//店铺名称
			iphone_J:"",//店铺电话
        }
    },

	//调用
	mounted(){
		var that = this;
		// console.log('uid',this.$store.getters.get_user_id)
		that.init();//--获取店铺信息
		that.$store.commit('bottom_nav', 3);//1.首页图标高量 2.购物车不处理 3.会员中心处理
	},

	//方法
	methods: {
		init(){
			var that = this;
			that.axios
			  .post(API.business,{
				  user_id: that.uid,
			  })
			  .then((res=>{
				  // console.log(res,'会员中心')
				  that.name_J = res.data.data.name;//店铺名称
				  that.iphone_J = res.data.data.phone;//店铺电话
			  }));
			  // console.log("测试",that.show);
		},
		login(){
			this.$dialog.confirm({
			  // title: '标题',
			  message: '是否退出',
			  width:"5.46rem",
			  className:'tit',
			}).then(() => {
			  // on confirm
			//确认 回到登入页面
			this.$store.commit('addUserId', false);
      //xhx 202506041934 添加为了定时清空uid,下方新增登清空操作
      // 清除无操作计时器
          if (this.$store.state.inactivityTimer) {
            clearTimeout(this.$store.state.inactivityTimer);
          }
			// console.log(this.$store.getters.get_user_id,'====uid')
			this.$router.push({path: '/'});
			}).catch(() => {});
		},
		address(){
			this.$router.push({path:'/addressmanagement'});
		},//跳转到地址

		// 跳转修改密码页
		amendPass(){
			this.$router.push({path: '/GoodsChangePass'});
		},
	}
}
</script>
<style lang="less" scoped>
	h1, h2, h3, h4, h5, h6,button{
		margin: 0rem;
		padding: 0rem;
	}

	img{
		list-style: none;
		border: 0rem;
	}

	.center_title{
		width: 100%;
		height: 1.48rem;
		border-bottom: 0.1rem solid rgba(237,237,237,1);
	}

	.center_title_img{
		width: auto;
		height: 100%;
		line-height: 1.48rem;
		display: inline-block;
		vertical-align: middle;
		margin-left: 0.42rem;
		margin-right: 0.22rem;
	}

	.center_title_img>img{
		height:0.54rem;
		display: inline-block;
		vertical-align: middle;
	}

	.center_title_text{
		width: auto;
		display: inline-block;
		vertical-align:middle;
		height: 100%;
	}

	.center_title_text>div{
		font-size:0.3rem;
		font-family:PingFangSC-Medium,PingFang SC;
		color:#6D6D6D;
		line-height:0.42rem;
	}

	.center_title_text>div:nth-child(1){
		margin-top: 0.3rem;
	}

	.center_title_text>div:nth-child(2){
		margin-top: 0.08rem;
	}

	.older{
		height: 2.26rem;
	}

	.older>h5{
		margin-left: 0.42rem;
		font-size:0.3rem;
		font-family:PingFangSC-Medium,PingFang SC;
		color:rgba(109,109,109,1);
		line-height:0.42rem;
		padding: 0.26rem 0;
	}

	.older>div{
		width: 6.66rem;
		margin: 0 auto;
	}

	.older>div>div{
		float: left;
		width: 49%;
		text-align: center;
		text-indent: 0.55rem;
	}

	.older>div>div>img{
		// height: 0.46rem;
		// display: block;
		// margin: 0.2rem auto 0 ;
		    height: 0.7rem;
    display: block;
    margin: 0rem 0 0 1.6rem;
	}
	.older>div>:nth-child(2) {
		text-indent: -0.1rem;
	}
	.older>div>:nth-child(2)>:nth-child(1) {
		height: 0.59rem;
		margin: 0.07rem 0 0.07rem 1.37rem;
	}

	.older>div>div>div{
		font-size:0.24rem;
		font-family:PingFangSC-Regular,PingFang SC;
		color:rgba(93,187,255,1);
	}

	.address{
		width: 7.5rem;
		overflow: hidden;
	}

	.address>div{
		width: 6.9rem;
		margin: auto;
		height: 1.14rem;
		line-height: 1.14rem;
		text-align: right;
		border-bottom: 0.01rem solid rgba(237,237,237,1);
	}

	.address>div>span{
		float: left;
		height: 100%;
		line-height: 1.14rem;
		font-size:0.3rem;
		font-family:PingFangSC-Regular,PingFang SC;
		color:rgba(99,99,99,1);
	}

	.address>div>img{
		display: inline-block;
		vertical-align: middle;
		width:0.2rem;
		height:0.34rem;
	}

	.center>button{
		width:6.4rem;
		background: #FFF;
		height:1.08rem;
		border-radius:0.6rem;
		border:0.02rem solid rgba(123,212,255,1);
		font-size:0.32rem;
		font-family:PingFangSC-Medium,PingFang SC;
		color:rgba(93,187,255,1);
		line-height: 1.08rem;
		margin: 1.98rem auto 0;
		display: block;
	}

	.tit{
		border-radius:0.1rem;
		color:rgba(99,99,99,1);
		font-size: 0.32rem;
		padding: 0.62rem 1.76rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/xy/home.vue